import { CateidType, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Catalog External ID Type|`;

type SharedKeys = Pick<
	LocDef,
	'portal' | 'displayType' | 'htmlAllowed' | 'portal' | 'shared' | 'feature'
>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.Core,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
};

export type CPCateidTypeLocs =
	| 'CPCateidTypeEnumCcat'
	| 'CPCateidTypeEnumCrcat'
	| 'CPCateidTypeEnumExcat'
	| 'CPCateidTypeEnumExcatDataProvider';

export type SPCateidTypeLocs =
	| 'SPCateidTypeEnumCcat'
	| 'SPCateidTypeEnumCrcat'
	| 'SPCateidTypeEnumExcat'
	| 'SPCateidTypeEnumExcatDataProvider';

export const cpCateidTypeEnumLocs: LocDefs<CPCateidTypeLocs> = {
	CPCateidTypeEnumCcat: {
		defaultValue: 'Credential Catalog',
		displayPath: `${dpRoot}Credential Catalog`,
		description: `System value for 'Credential Catalog' External ID type`,
		...sharedCpLocData,
	},
	CPCateidTypeEnumCrcat: {
		defaultValue: 'Other Requirement Catalog',
		displayPath: `${dpRoot}Other Requirement Catalog`,
		description: `System value for 'Certification Requirement Catalog' External ID type`,
		...sharedCpLocData,
	},
	CPCateidTypeEnumExcat: {
		defaultValue: 'Exam Catalog',
		displayPath: `${dpRoot}Excat`,
		description: `System value for 'Exam Catalog' External ID type`,
		...sharedCpLocData,
	},
	CPCateidTypeEnumExcatDataProvider: {
		defaultValue: 'External Data',
		displayPath: `${dpRoot}External Catalog Data Provider`,
		description: `System value for 'External Catalog Data Provider' External ID type`,
		...sharedCpLocData,
	},
};

export const spCateidTypeEnumLocs: LocDefs<SPCateidTypeLocs> = {
	SPCateidTypeEnumCcat: {
		defaultValue: 'Credential Catalog',
		displayPath: `${dpRoot}Ccat`,
		description: `System value for 'Credential Catalog' External ID type`,
		legacyName: 'Core/System.Enum.CateidType.Ccat',
		...sharedSpLocData,
	},
	SPCateidTypeEnumCrcat: {
		defaultValue: 'Other Requirement Catalog',
		displayPath: `${dpRoot}Crcat`,
		description: `System value for 'Other Requirement Catalog' External ID type`,
		legacyName: 'Core/System.Enum.CateidType.Crcat',
		...sharedSpLocData,
	},
	SPCateidTypeEnumExcat: {
		defaultValue: 'Exam Catalog',
		displayPath: `${dpRoot}Excat`,
		description: `System value for 'Exam Catalog' External ID type`,
		legacyName: 'Core/System.Enum.CateidType.Excat',
		...sharedSpLocData,
	},
	SPCateidTypeEnumExcatDataProvider: {
		defaultValue: 'External Data',
		displayPath: `${dpRoot}External Catalog Data Provider`,
		description: `System value for 'External Catalog Data Provider' External ID type`,
		legacyName: 'Core/System.Enum.CateidType.ExcatDataProvider',
		...sharedSpLocData,
	},
};

export const CATEID_TYPE_ENUM_LOCS = MapLocKeys<CPCateidTypeLocs | SPCateidTypeLocs>({
	...cpCateidTypeEnumLocs,
	...spCateidTypeEnumLocs,
});

export type CPCateidTypeEnumLocType = LocMap<CPCateidTypeLocs>;
export type SPCateidTypeEnumLocType = LocMap<SPCateidTypeLocs>;

export const cpCateidTypeKeys: { [key in CateidType]: keyof CPCateidTypeEnumLocType } = {
	[CateidType.Ccat]: CATEID_TYPE_ENUM_LOCS.CPCateidTypeEnumCcat,
	[CateidType.Crcat]: CATEID_TYPE_ENUM_LOCS.CPCateidTypeEnumCrcat,
	[CateidType.Excat]: CATEID_TYPE_ENUM_LOCS.CPCateidTypeEnumExcat,
	[CateidType.ExcatDataProvider]: CATEID_TYPE_ENUM_LOCS.CPCateidTypeEnumExcatDataProvider,
};

export const spCateidTypeKeys: { [key in CateidType]: keyof SPCateidTypeEnumLocType } = {
	[CateidType.Ccat]: CATEID_TYPE_ENUM_LOCS.SPCateidTypeEnumCcat,
	[CateidType.Crcat]: CATEID_TYPE_ENUM_LOCS.SPCateidTypeEnumCrcat,
	[CateidType.Excat]: CATEID_TYPE_ENUM_LOCS.SPCateidTypeEnumExcat,
	[CateidType.ExcatDataProvider]: CATEID_TYPE_ENUM_LOCS.SPCateidTypeEnumExcatDataProvider,
};
